import { ApiError } from '../errors/api-error.js';
import { withRetry } from '../utils/retry.js';

export class WorkflowTemplateService {
    constructor(api, config = {}) {
        this.api = api;
        this.config = config;
    }

    async getAll(params = {}) {
        try {
            const r = await withRetry(() => this.api.getAll(params), { maxRetries: 2 });
            return {
                success: true,
                data: r.data || [],
                pagination: r.pagination || {},
                message: r.message,
            };
        } catch (e) { throw this._handle(e, 'Failed to list workflow templates'); }
    }

    async getById(id) {
        try {
            const r = await withRetry(() => this.api.getById(id), { maxRetries: 2 });
            return { success: true, data: r.data, message: r.message };
        } catch (e) { throw this._handle(e, 'Failed to fetch workflow template'); }
    }

    async create(data) {
        try {
            const r = await this.api.create(data);
            return { success: true, data: r.data, message: r.message || 'Şablon oluşturuldu' };
        } catch (e) { throw this._handle(e, 'Failed to create workflow template'); }
    }

    async update(id, data) {
        try {
            const r = await this.api.update(id, data);
            return { success: true, data: r.data, message: r.message || 'Şablon güncellendi' };
        } catch (e) { throw this._handle(e, 'Failed to update workflow template'); }
    }

    async validate(payload) {
        try {
            const r = await this.api.validate(payload);
            return { success: true, valid: r.valid, details: r.details };
        } catch (e) { throw this._handle(e, 'Workflow template validation failed'); }
    }

    async getPayloadShape(params) {
        try {
            const r = await this.api.getPayloadShape(params);
            return { success: true, data: r.data, message: r.message };
        } catch (e) { throw this._handle(e, 'Failed to load workflow payload shape'); }
    }

    async publish(id) {
        try {
            const r = await this.api.publish(id);
            return { success: true, data: r.data, message: r.message || 'Şablon yayınlandı' };
        } catch (e) { throw this._handle(e, 'Failed to publish workflow template'); }
    }

    async cloneToNewVersion(id, payload) {
        try {
            const r = await this.api.cloneToNewVersion(id, payload);
            return { success: true, data: r.data, message: r.message || 'Yeni versiyon oluşturuldu' };
        } catch (e) { throw this._handle(e, 'Failed to clone workflow template'); }
    }

    async delete(id) {
        try {
            const r = await this.api.delete(id);
            return { success: true, data: r.data, message: r.message || 'Şablon silindi' };
        } catch (e) { throw this._handle(e, 'Failed to delete workflow template'); }
    }

    _handle(error, fallback) {
        if (error instanceof ApiError) throw error;
        if (error.statusCode || error.status) throw ApiError.fromResponse(error);
        throw new ApiError(error.message || fallback, 500, 'UNKNOWN_ERROR', error);
    }
}
